import { SET_TOPSCORES_DATA } from "../actions/action_topscores";
import { SET_TOPSCORES_SHOWLOADER } from "../actions/action_topscores";

const initialState = {
  data: {scores:[],total:100},
  numRows: 0,
  fxrows: 0,
  phrows: 0,
  srrows: 0,
  vtrows: 0,
  pbrows: 0,
  hbrows: 0,
  showLoader: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TOPSCORES_DATA:
      var newState = {
        data: action.payload,
        numRows: action.payload.scores.length,
        fxrows: action.payload.floor.length,
        phrows: action.payload.phorse.length,
        srrows: action.payload.rings.length,
        vtrows: action.payload.vault.length,
        pbrows: action.payload.pbars.length,
        hbrows: action.payload.highbar.length,
        showLoader: false
      };
      return { ...state, ...newState };
    case SET_TOPSCORES_SHOWLOADER:
      return { ...state, showLoader: action.payload };
    default:
      return state;
  }
}
